import { render } from "./ReturnFormTabPaymentHistory.vue?vue&type=template&id=0ef02d58"
import script from "./ReturnFormTabPaymentHistory.vue?vue&type=script&lang=js"
export * from "./ReturnFormTabPaymentHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__